import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 420px;
  margin: 0 auto;
  text-align: left;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
  margin: 1rem 0;
`;

export const Text = styled.p`
  font-size: 20px;
  margin: 1rem 0;
`;
